import { Container, Heading } from '@dbi-tools/ui-kit';
import { Img } from '@dbi-tools/ui-kit/lib/img';
import blkLogo from '@quiz-frontend/markup/images/blk-logo.jpg';
import React, { Fragment } from 'react';

import { Question } from '../../types';
import StepsCounter from '../common/steps-counter';
import QuestionSubText from '../question-sub-text';
import QuestionLayout from '../questions/question.layout';
import { MainWhiteStyled } from './styled/main.styled';

const RowsStepLayout: React.FC<{ question: Question; title: string }> = ({ question }) => {
  return (
    <Fragment>
      <Container>
        <MainWhiteStyled groomsmen={question.name === 'groomsmen'}>
          <StepsCounter />
          <Heading as="h1" measure={{ xs: 'h4', md: 'h3' }} mb={15}>
            {question?.question}
          </Heading>
          <QuestionSubText text={question?.text} scrollingIcon={question.options.length > 10} />
          {question.name === 'groomsmen' && <Img height={70} src={blkLogo.src} />}
        </MainWhiteStyled>
      </Container>
      <br />
      {question && <QuestionLayout question={question} />}
    </Fragment>
  );
};

export default RowsStepLayout;
